/**
 *
 * ModalRankSignaling
 *
 */

import React from "react"
import { Modal, InputNumber, Form, Button } from "antd"
import { PhotoshopPicker, HuePicker } from "react-color"
import { values, isEqual, findIndex, omit } from "lodash"

import calculateSignaling from "../../utils/calculate-signaling"
import percentIcon from "../../images/percent-icon.svg"
import "./index.less"
import { buttonAction_btns } from "../Snowplow/config2"

const FormItem = Form.Item

/* eslint-disable react/prefer-stateless-function */
class ModalRankSignaling extends React.Component {
  state = {
    start: 0,
    finish: 0,
    rgb: {
      r: 255,
      g: 255,
      b: 255,
      a: 1,
    },
    showButtonApply: false,
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps.boxSelected, this.props.boxSelected)) {
      this.setState({ ...this.props.boxSelected })
    }
  }

  handlePhotoshopChange = (color, event) => {
    this.setState(
      {
        ...omit(this.state, ["showButtonApply"]),
        rgb: color.rgb,
      },
      () => {
        const orderBoxs = this.props.boxsItems
        const getIndexBox = findIndex(
          this.props.boxsItems,
          (item) => item.id == this.props.boxSelected.id
        )
        orderBoxs.splice(getIndexBox, 1, omit(this.state, ["showButtonApply"]))

        this.props.stateStateFrom("boxs", orderBoxs)
      }
    )
  }

  hangeRgbChange = (name, value) => {
    this.setState(
      {
        ...omit(this.state, ["showButtonApply"]),
        rgb: {
          ...this.state.rgb,
          [name]: value,
        },
      },
      () => {
        const orderBoxs = this.props.boxsItems
        const getIndexBox = findIndex(
          this.props.boxsItems,
          (item) => item.id == this.props.boxSelected.id
        )
        orderBoxs.splice(getIndexBox, 1, omit(this.state, ["showButtonApply"]))

        this.props.stateStateFrom("boxs", orderBoxs)
      }
    )
  }

  setValueApply = () => {
    const colorsSet = calculateSignaling({
      arrayObjects: this.props.boxsItems,
      boxSelected: omit(this.state, ["showButtonApply"]),
      finishValue: this.state.finish,
    })

    this.props.stateStateFrom("boxs", colorsSet)

    this.setState({ showButtonApply: false })
  }

  setFinishValue = (value) => {
    this.setState({
      finish: value,
      showButtonApply: true,
    })
  }

  setDisableButtonSave = () => {
    const { report_color_range } = this.props.configuration
    if (!report_color_range) return true

    return isEqual(
      JSON.stringify(report_color_range),
      JSON.stringify(this.props.boxsItems)
    )
  }

  render() {
    return (
      <Modal
        className="container-rank-signaling"
        title="Semaforización de rangos"
        visible={this.props.visible}
        width={662}
        okButtonProps={{ disabled: this.setDisableButtonSave() }}
        onCancel={() => {
          this.props.getConfigurationWatcher()
          this.props.stateStateFrom("modalRankSignaling", false)
          this.props.stateStateFrom("boxSelected", {})
          this.setState({ showButtonApply: false })
        }}
        onOk={() => {
          this.props.stateStateFrom("modalRankSignaling", false)
          this.props.stateStateFrom("boxSelected", {})
          this.setState({ showButtonApply: false })
          this.props.putConfigurationWatcher({
            report_color_range: JSON.stringify(this.props.boxsItems),
          })
          buttonAction_btns("Semaforización de rangos - Guardar")
        }}
        okText="Guardar">
        <div className="container-configuration__boxs container-rank-signaling__boxs">
          {this.props.boxs}
        </div>
        <div
          className="container-rank-signaling__restore-colors"
          onClick={this.props.restoreColors}>
          Restablecer colores
        </div>
        <Form className="container-rank-signaling__form">
          <FormItem label="Desde" className="item_range">
            <div className="container-rank-signaling__form-from">
              <InputNumber
                disabled
                value={`${this.state.start}%`}
                min={0}
                max={100}
              />
            </div>
          </FormItem>
          <FormItem label="Hasta" className="item_range">
            <div className="container-rank-signaling__form-from">
              <InputNumber
                value={`${this.state.finish}%`}
                min={Number(this.state.start) + 1}
                max={100}
                onChange={this.setFinishValue}
              />
            </div>
          </FormItem>
          {/* { (this.props.boxSelected.finish != this.state.finish && this.state.showButtonApply) && */}
          {this.state.showButtonApply && (
            <Button type="primary" onClick={this.setValueApply}>
              Aplicar
            </Button>
          )}
        </Form>
        <div className="color-black container-rank-signaling__color-title">
          Color
        </div>
        <div className=" container-rank-signaling__colors">
          <div>
            <PhotoshopPicker
              className="color-black container-rank-signaling__photoshop"
              color={this.state.rgb}
              onChangeComplete={this.handlePhotoshopChange}
            />
            <div className="color-black container-rank-signaling__color-footer">
              <div
                className="container-rank-signaling__colorpicked"
                style={{
                  backgroundColor: `rgb(${values(this.state.rgb).join(", ")})`,
                }}
              />
              <HuePicker
                onChangeComplete={this.handlePhotoshopChange}
                color={this.state.rgb}
                className="container-rank-signaling__hue"
              />
            </div>
          </div>
          <div>
            <div
              className="color-black container-rank-signaling__color-title"
              style={{ marginTop: 0, marginBottom: 8 }}>
              RGB
            </div>
            <div className="container-rank-signaling__colors-rgb">
              <InputNumber
                min={0}
                max={255}
                value={this.state.rgb.r}
                onChange={(e) => {
                  if (!e) {
                    this.hangeRgbChange("r", 0)
                  } else {
                    this.hangeRgbChange("r", e)
                  }
                }}
              />
              <InputNumber
                min={0}
                max={255}
                value={this.state.rgb.g}
                onChange={(e) => {
                  if (!e) {
                    this.hangeRgbChange("g", 0)
                  } else {
                    this.hangeRgbChange("g", e)
                  }
                }}
              />
              <InputNumber
                min={0}
                max={255}
                value={this.state.rgb.b}
                onChange={(e) => {
                  if (!e) {
                    this.hangeRgbChange("b", 0)
                  } else {
                    this.hangeRgbChange("b", e)
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalRankSignaling
